define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntityValidationState = exports.EntityValidationStateMsg = exports.MessageType = void 0;
    var MessageType;
    (function (MessageType) {
        MessageType[MessageType["Error"] = 0] = "Error";
        MessageType[MessageType["Warning"] = 1] = "Warning";
        MessageType[MessageType["Info"] = 2] = "Info";
    })(MessageType || (exports.MessageType = MessageType = {}));
    class EntityValidationStateMsg {
        constructor(type, id, field, msg) {
            Object.defineProperty(this, "Type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QualifiedField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FieldOwner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Field", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Msg", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Alias", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.Type = type;
            this.Id = id;
            this.QualifiedField = field;
            this.Msg = msg;
            if (this.QualifiedField) {
                this.FieldOwner = this.QualifiedField.substr(0, this.QualifiedField.indexOf(".")).toLowerCase();
            }
            if (this.QualifiedField) {
                this.Field = this.QualifiedField.substr(this.QualifiedField.indexOf(".") + 1);
            }
        }
    }
    exports.EntityValidationStateMsg = EntityValidationStateMsg;
    class EntityValidationState {
        get HasMessages() {
            return this.Messages.length > 0;
        }
        constructor(id, alias) {
            Object.defineProperty(this, "Messages", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HasErrors", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "HasWarnings", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "HasInfo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "Id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Alias", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.Id = id;
            this.Alias = alias;
            this.Messages = [];
        }
        add(validationState) {
            if (validationState.HasMessages) {
                this.Messages.push(validationState);
                this.HasErrors = this.HasErrors || validationState.HasErrors;
                this.HasWarnings = this.HasWarnings || validationState.HasWarnings;
                this.HasInfo = this.HasInfo || validationState.HasInfo;
            }
        }
        addError(m) {
            let msg = typeof m == "string" ? new EntityValidationStateMsg(MessageType.Error, null, null, m) : new EntityValidationStateMsg(MessageType.Error, m.Id, m.Field, m.Msg);
            this.Messages.push(msg);
            this.HasErrors = true;
        }
        addWarning(m) {
            let msg = typeof m == "string" ? new EntityValidationStateMsg(MessageType.Warning, null, null, m) : new EntityValidationStateMsg(MessageType.Warning, m.Id, m.Field, m.Msg);
            this.Messages.push(msg);
            this.HasWarnings = true;
        }
        addInfo(m) {
            let msg = typeof m == "string" ? new EntityValidationStateMsg(MessageType.Info, null, null, m) : new EntityValidationStateMsg(MessageType.Info, m.Id, m.Field, m.Msg);
            this.Messages.push(msg);
            this.HasInfo = true;
        }
        flatten() {
            let flattened = [];
            this.Messages.forEach(m => {
                if (m instanceof EntityValidationState) {
                    flattened = flattened.concat(m.flatten());
                }
                else {
                    m.Alias = `${this.Alias} (${this.Id})`;
                    flattened.push(m);
                }
            });
            let processed = new Set();
            return flattened.filter(x => {
                let k = `${x.Type}-${x.Id}-${x.Msg}`;
                if (!processed.has(k)) {
                    processed.add(k);
                    return true;
                }
                return false;
            });
        }
        addValidationResult(res) {
            if (res) {
                if (res.HasErrors && res.Errors.length > 0) {
                    for (let m of res.Errors) {
                        this.addError(m);
                    }
                }
                if (res.HasWarnings && res.Warnings.length > 0) {
                    for (let m of res.Warnings) {
                        this.addWarning(m);
                    }
                }
                if (res.HasInfo && res.Info.length > 0) {
                    for (let m of res.Info) {
                        this.addInfo(m);
                    }
                }
            }
        }
        addEntityCollectionValidationResult(entity, res) {
            if (res && res.Entity) {
                for (let validationResult of res.Entity) {
                    let validationState = new EntityValidationState(validationResult.Id, "");
                    validationState.addValidationResult(validationResult);
                    this.add(validationState);
                }
                let messages = this.flatten();
                entity.walk(x => {
                    let xClassName = x.constructor.Name.toLowerCase();
                    for (let m of messages) {
                        if (m.FieldOwner) {
                            if (xClassName == m.FieldOwner && x.Id == m.Id) {
                                x[m.Field + "Error"] = m.Msg;
                            }
                        }
                    }
                });
            }
        }
    }
    exports.EntityValidationState = EntityValidationState;
});
